import { z } from 'zod';

import { request } from '@/api/httpClient';

export const shoppingStatuses = [
  'Requested',
  'Ordered',
  'In Stock',
  'On Van',
  'Installed',
] as const;
export interface ShoppingItem {
  id: number;
  description: string;
  status: number;
  bodyId: number;
  bodyName: string;
  locationName: string;
  clientName: string;
}
const itemSchema = z.object({
  id: z.number().int().positive(),
  description: z.string(),
  status: z.coerce.number().int().min(0).max(4),
  body_of_water_id: z.number().int().positive(),
  body_of_water: z.object({
    name: z.string(),
    service_location: z.object({ name: z.string(), client: z.object({ name: z.string() }) }),
  }),
});
export async function getShoppingItems(): Promise<ShoppingItem[]> {
  return z
    .array(itemSchema)
    .parse(await request<unknown>('/managers/shopping-list-items'))
    .map((item) => ({
      id: item.id,
      description: item.description,
      status: item.status,
      bodyId: item.body_of_water_id,
      bodyName: item.body_of_water.name,
      locationName: item.body_of_water.service_location.name,
      clientName: item.body_of_water.service_location.client.name,
    }));
}
export async function getBodies(clientId: number, locationId: number) {
  const value = await request<unknown>(
    `/managers/clients/${clientId}/service-locations/${locationId}/bodies-of-water`,
  );
  return z.array(z.object({ id: z.number().int().positive(), name: z.string() })).parse(value);
}
export async function createShoppingItem(description: string, status: number, bodyId: number) {
  return z.object({ id: z.number().int().positive() }).parse(await request<unknown>('/managers/shopping-list-items', {
    method: 'POST',
    body: { description, status, body_of_water_id: bodyId },
  }));
}
export async function updateShoppingItem(id: number, status: number) {
  await request(`/managers/shopping-list-items/${id}`, { method: 'PUT', body: { status } });
  return { id };
}
export async function deleteShoppingItem(id: number) {
  await request(`/managers/shopping-list-items/${id}`, { method: 'DELETE' });
}
